export default __webpack_public_path__ + "static/media/slide3.82994efc.jpg";